let $ = jQuery

$(document).gp_ready(init_collapse)

function init_collapse() {
	$('.filter-collapse .filter-collapse__header').off("click").click(function () {
		let $filter = $(this).closest('.filter-collapse')
		toggle_collapse($filter)
	})
}

function toggle_collapse($filter) {
	if (!$filter.hasClass('opened')) {
		open_collapse($filter, false)
	} else {
		close_collapse($filter)
	}
}

export function open_collapse($filter, scroll_parent) {

	$filter.addClass('opened');
	$filter.children('.filter-collapse__content').slideDown(200);

	if (scroll_parent) {
		setTimeout(function () {
			let $parent = $filter.closest('.sidebar__content')
			$parent.animate({
				scrollTop: $filter.offset().top + $parent.scrollTop() - $filter.offsetParent().offset().top - 120
			}, 300)
		}, 200)
	}

}

function close_collapse($filter) {
	$('body').trigger('hide_overlay');
	$filter.removeClass('opened');
	$filter.children('.filter-collapse__content').slideUp(200);
}
